<template>
    <div class="header active">
        <div class="header-layout">
            <mq-layout :mq="['xl', 'hd', 'inf']">
                <div class="fixed-header fade" :class="{active: active_menu.columns}">
                    <div class="container is-boxed-fluid" v-show="!search_open">
                        <div class="row c-nb">
                            <div class="col-2">
                                <router-link :to="{name: 'home'}" class="logo">
                                    <img :src="'/img/logo.svg'" alt="">
                                </router-link>
                            </div>
                            <div class="col-8">
                                <ul class="main-menu">
                                    <li v-for="(item, key) in $store.state.app.navigation" :key="Math.random()+key" @mouseover="active_menu = !disable_mega_menu ? item : false" @mouseleave="disable_mega_menu=false">
                                        <router-link :to="item.slug" :target="item.blank=='true'?'_blank':''">{{item.label}}</router-link>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-2">
                                <ul class="shop-actions">
                                    <li @click="open_search_form()"><i class="icon-search"></i></li>
                                    <li><router-link :to="$i18nRoute({name: 'favorites'})"><i class="icon-favorite"></i><span class="counter">{{$store.state.favorite.items.length}}</span></router-link></li>
                                    <li><router-link :to="$i18nRoute({name: 'cart'})"><i class="icon-shopping-bag"></i><span class="counter">{{$store.state.cart.count}}</span></router-link></li>
                                    <li v-if="$store.state.auth.is_auth"><router-link :to="$i18nRoute({name: 'my-account', params: {page: 'profile'}})"><i class="icon-user"></i></router-link></li>
                                    <li v-else><router-link :to="$i18nRoute({name: 'login'})"><i class="icon-user"></i></router-link></li>
                                    <li>
                                        <lang></lang>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="container" v-show="search_open">
                        <div class="search-input">
                            <input type="text" :autofocus="true" v-model="search_query" @keyup.enter="run_search()" :placeholder="$t('search_placeholder')" ref="search">
                            <span class="icon-close" @click="search_open=false"></span>
                        </div>
                    </div>
                </div>
                <div class="main-header fade" :class="{active: active_menu.submenu}">
                    <div class="white-logo">
                        <img src="/img/logo-white.svg" class="light-logo" alt="">
                        <img src="/img/logo.svg" class="dark-logo" alt="">
                    </div>
                    <div class="main-navigation">
                        <ul class="main-menu">
                            <li v-for="(item, key) in $t('nav')" :key="Math.random()" @mouseover="active_menu=item">
                                <router-link :to="item.name">{{item.text}}</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </mq-layout>

            <mq-layout :mq="['xs', 'sm', 'ms', 'md', 'lg']">
                <div class="container is-fluid mobile-header">
                    <div class="mobile-navigation fade" v-show="!mobile_search_open">
                        <div class="mobile-menu">
                            <div @click="mobile_menu_open=true">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                        <div class="mobile-logo">
                            <router-link :to="{name: 'home'}" class="logo">
                                <img :src="'/img/logo...svg'" alt="">
                            </router-link>
                        </div>
                        <div class="shop-actions">
                            <ul class="shop-actions">
                                <li @click="mobile_search_open=true"><i class="icon-search"></i></li>
                                <li><router-link :to="{name: 'favorites'}"><i class="icon-favorite"></i><span class="counter">{{$store.state.favorite.items.length}}</span></router-link></li>
                                <li><router-link :to="{name: 'cart'}"><i class="icon-shopping-bag"></i><span class="counter">{{$store.state.cart.count}}</span></router-link></li>
                            </ul>
                        </div>
                    </div>

                    <div class="mobile-search fade" v-show="mobile_search_open">
                        <input type="text" @keyup.enter="run_search()" :placeholder="$t('search_placeholder')">
                        <div>
                            <span class="close-search" @click="mobile_search_open=false"></span>
                        </div>
                    </div>
                </div>
            </mq-layout>
        </div>

        <mq-layout class="mobile-nav-sidebar" :class="{active: mobile_menu_open}" :mq="['xs', 'sm', 'ms', 'md', 'lg']">
            <div class="heading">
                <div class="close-sidebar" v-if="!mobile_sub_open" @click="mobile_menu_open=false;mobile_sub_open=false;active_menu=[]"></div>
                <div class="close-sub icon-left-arrow" @click="mobile_sub_open=false;active_menu=[]" v-if="mobile_sub_open"></div>
                <div class="sidebar-logo">
                    <router-link :to="$i18nRoute({name: 'home'})" class="logo">
                        <img :src="'/img/logo.svg'" alt="">
                    </router-link>
                </div>
                <div class="close-sidebar" v-if="mobile_sub_open" @click="mobile_menu_open=false;mobile_sub_open=false;active_menu=[]"></div>
            </div>
            <div class="mobile-nav">
                <div :class="{active: mobile_sub_open}">
                    <ul class="mobile-main-menu">
                        <li v-for="(item, key) in $store.state.app.navigation" :key="Math.random()">
                            <router-link :to="item.slug" v-if="!item.submenu">{{item.label}}</router-link>
                            <div v-else @click="active_menu=item;mobile_sub_open=true">{{item.label}}<span></span></div>
                        </li>
                    </ul>
                    <ul class="mobile-sub-menu">
                        <template v-for="(col, col_key) in active_menu.submenu" v-if="active_menu.submenu">
                            <li>
                                <router-link :to="col.slug" v-if="!col.submenu">{{col.label}}</router-link>
                                <div v-else @click="active_menu=col;mobile_sub_open=true">{{item.label}}<span></span></div>
                            </li>
                        </template>
                    </ul>
                </div>
                <div class="main-pages">
                    <lang></lang>
                    <div v-if="!$store.state.auth.is_auth"><router-link :to="$i18nRoute({name: 'login'})"><i class="icon-user"></i>{{$t('signin_signup')}}</router-link></div>
                    <div v-else><router-link :to="$i18nRoute({name: 'my-account', params: {page: 'profile'}})"><i class="icon-user"></i>{{$t('my_account')}}</router-link></div>
                    <div v-if="$store.state.auth.is_auth" @click="logout()"><i class="icon-share"></i>{{$t('logout')}}</div>
                </div>
            </div>
        </mq-layout>

        <mq-layout class="mega-menu" v-if="active_menu.columns" :class="{active: mobile_menu_open}" :mq="['xl', 'hd', 'inf']">
            <div @mouseleave="active_menu=[]">
                <div class="container">
                    <div class="row c-nb">
                        <div class="col-2"></div>
                        <div class="col-3" v-for="(col, key_1) in active_menu.columns" :key="key_1">
                            <ul>
                                <li v-for="(item, key) in col" :key="key">
                                    <router-link :to="item.slug" :target="item.blank=='true'?'_blank':''">{{item.label}}</router-link>
                                </li>
                            </ul>
                        </div>
                        <div class="col-2"></div>
                    </div>
                </div>
            </div>
        </mq-layout>
        <div class="mega-menu-overlay" @click="search_open=false;mobile_search_open=false;active_menu.submenu=false" v-if="active_menu.submenu || search_open || mobile_search_open || mobile_menu_open"></div>
    </div>
</template>

<script>
  import Api from '@/services/api-service';
  import Lang from '@/components/global/LangSwitch'
  export default {
    components: {
        Lang
    },
    data () {
      return {
        search_query: "",
        search_open: false,
        mobile_search_open: false,
        active_menu: false,
        mobile_menu_open: false,
        mobile_sub_open: false,
        mobile_sub_menu_childs: [],
        scrolled: false,
        fixedPosition: 0,
        disable_mega_menu: false
      }
    },
    created() {
      window.addEventListener("scroll", this.handleScroll);
      if(this.$route.name != 'home'){
        this.scrolled = true
      }
    },
    watch: {
      '$route' (to, from) {
        if(from.name == 'home' || to.name != 'home' || window.scrollY > 0){
          this.scrolled = true
        }else{
          this.scrolled = false
        }
        this.active_menu = false
        this.disable_mega_menu = true
        this.mobile_menu_open = false
        this.mobile_sub_open = false
      }
    },
    methods: {
      loadNavigation () {
        Api.post('/load-navigation')
          .then(response => {
            this.navigation = response.data.navigation
          })
          .catch(error => {
            console.log(error)
          })
      },
      handleScroll() {
        if(this.$route.name == 'home'){
          if (this.fixedPosition < window.scrollY) {
            this.scrolled = true;
          }else{
            this.scrolled = false;
            this.search_open = false;
          }
        }
      },
      open_search_form () {
        var self = this
        self.search_open = true
        setTimeout(function () {
          self.$refs.search.focus()
        })
      },
      run_search () {
        if(this.search_query != "") {
          this.search_open = false
          var params = Object.assign({}, this.$route.params);
          var query = Object.assign({}, this.$route.query);
          params.locale = this.$i18n.locale
          query.q = this.search_query
          this.$router.push({
            name: "shop",
            params: params,
            query: query
          })
        }
      },
      logout () {
        this.$store.dispatch('fetchAuth', false)
        window.localStorage.setItem('id_token', false)
        this.$router.push({ name: 'login' })
      }
    }
  }
</script>

<style lang="scss">
    .header{
        z-index: 9999999;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;

        .header-layout{
            position: relative;
            z-index: 9999;
        }

        &.active{
            .fixed-header{
                display: block;
            }
            .main-header{
                display: none;
            }
            .mega-menu{
                padding-top: 120px;
            }
        }

        &:not(.active){
            .fixed-header{
                display: none;
            }
            .main-header{
                display: block;
            }
            .mega-menu{
                padding-top: 180px;
            }
        }

        .mobile-header{
            box-shadow: 0 0px 10px 0px #00000029;
            position: sticky;
            height: 55px;
            top: 0;
            background: #fff;

            .mobile-navigation{
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: relative;
                z-index: 99999;
                &>div{
                    flex: 0 0 auto;
                }
            }

            .mobile-menu{
                width: 15%;
                div{
                    width: 27px;
                    span{
                        display: block;
                        border-bottom: 1px solid $main-color;
                        &:not(:last-child){
                            margin-bottom: 8px;
                        }
                    }
                }
            }
            .mobile-logo{
                text-align: center;
                img{
                    display: block;
                    height: 35px;
                }
            }
            .shop-actions{
                width: 15%;
                ul{
                    li{
                        margin-left: 15px;
                        i{
                            font-size: 18px;
                        }
                    }
                }
            }
            .mobile-search{
                padding-top: 17px;
                padding-bottom: 17px;
                display: flex;
                input{
                    height: 30px;
                    border: 0;
                    outline: none;
                    border-bottom: 1px solid rgba(30, 30, 30, 0.5);
                    width: 100%;
                    @include placeholder{
                        color: rgba(30, 30, 30, 0.5);
                        font-size: 16px;
                    };
                }
                div{
                    width: 40px;
                    .close-search{
                        right: 15px;
                        width: 25px;
                    }
                }
            }
        }

        .mobile-nav-sidebar{
            position: fixed;
            top: 0;
            bottom: 0;
            width: 340px;
            background: #fff;
            z-index: 9999999;
            box-shadow: -5px 0 15px rgba(0, 0, 0, 0.16);
            left: -105%;
            transition: all 0.6s;
            opacity: 0;

            &.active{
                left: 0;
                opacity: 1;
            }

            .heading{
                position: relative;
                padding: 15px;
                display: flex;
                align-items: center;
                .close-sidebar{
                    width: 25px;
                    height: 25px;
                    position: relative;

                    &:before, &:after{
                        display: block;
                        content: "";
                        border-bottom: 1px solid $main-color;
                        height: 1px;
                        position: absolute;
                        left: 0;
                        right: 0;
                        top: 0;
                        bottom: 0;
                        margin: auto;
                    }
                    &:before{
                        transform: rotate(45deg);
                    }
                    &:after{
                        transform: rotate(-45deg);
                    }
                }

                .sidebar-logo{
                    flex: 1 0 auto;
                    text-align: center;
                    img{
                        display: inline-block;
                        height: 40px;
                    }
                }
            }

            .mobile-nav{
                padding: 0 15px;
                margin-top: 30px;
                overflow: scroll;
                position: absolute;
                left: 0;
                bottom: 0;
                top: 60px;
                right: 0;
                overflow: auto;
                -webkit-overflow-scrolling: touch;

                &>div:first-child{
                    display: flex;
                    flex-wrap: nowrap;
                    overflow: hidden;
                    &.active{
                        ul{
                            transform: translateX(-100%);
                        }
                    }
                    ul{
                        transform: translateX(0);
                        width: 100%;
                        flex-basis: 100%;
                        flex: 0 0 auto;
                        background: #ffffff;
                        transition: all 0.3s;
                        li{
                            display: block;
                            border-bottom: 1px solid rgba(0, 0, 0, 0.16);
                            position: relative;

                            &.sub-title{
                                color: rgba(30, 30, 30, 0.5);
                                font-family: $font-bold;
                                padding-top: 10px;
                                padding-bottom: 10px;
                            }

                            a, div{
                                display: block;
                                padding-top: 10px;
                                padding-bottom: 10px;
                                font-size: 16px;

                                &>span{
                                    display: flex;
                                    width: 45px;
                                    position: absolute;
                                    top: 0;
                                    bottom: 0;
                                    right: 0;
                                    justify-content: center;
                                    align-items: center;

                                    &:after{
                                        content: "";
                                        display: block;
                                        width: 10px;
                                        height: 10px;
                                        border-bottom: 1px solid $main-color;
                                        border-right: 1px solid $main-color;
                                        transform: rotate(-45deg);
                                    }
                                }
                            }

                        }
                    }
                }

                .main-pages{
                    margin-top: 30px;
                    i{
                        display: inline-block;
                        width: 30px;
                    }
                    &>div{
                        margin-bottom: 15px;
                    }
                }
            }
        }

        .fixed-header{
            background-color: #fff;
            position: relative;
            z-index: 3000;
            padding-top: 15px;
            padding-bottom: 15px;
            animation: fade 0.6s;

            &:not(.active){
                box-shadow: 0px 3px 6px #0000001A;
            }
        }

        .main-header{
            text-align: center;
            position: relative;
            z-index: 3000;
            padding-top: 15px;
            padding-bottom: 15px;
            animation: fade 0.6s;

            .dark-logo{
                display: none;
            }

            .main-navigation{
                max-width: 1200px;
                margin: auto;
                a{
                    color: #fff;
                }
            }

            &.active{
                .light-logo{
                    display: none;
                }
                .dark-logo{
                    display: inline;
                }
                .main-navigation{
                    max-width: 1200px;
                    margin: auto;
                    a{
                        color: $main-color;
                    }
                }
            }

            .main-navigation{
                max-width: 1200px;
                margin: auto;
                a{
                    color: #fff;
                }
            }
        }

        .logo{
            img{
                height: 45px;
                @include mq($ms){
                    height: 35px;
                }
            }
        }
        .main-menu{
            width: 100%;
            display: flex;
            height: 45px;
            justify-content: center;
            align-items: center;

            @include mq($ms){
                height: 55px;
            }

            a{
                position: relative;
                padding-left: 15px;
                padding-right: 15px;

                &.disabled{
                    pointer-events: none;
                    cursor: pointer;
                }

                @include mq($hd){
                    font-size: 14px;
                }

                @include mq($xl){
                    font-size: 14px;
                }

                &:hover{
                    &:after{
                        content: "";
                        position: absolute;
                        left: 0;
                        right: 0;
                        bottom: -10px;
                        border-bottom: 1px solid $main-color;
                    }

                }
            }
        }
        .shop-actions{
            width: 100%;
            display: flex;
            height: 45px;
            justify-content: flex-end;
            align-items: center;

            @include mq($ms){
                height: 55px;
            }

            li{
                margin-left: 30px;
                cursor: pointer;
                position: relative;

                i{
                    font-size: 20px;
                }

                .counter{
                    position: absolute;
                    min-width: 15px;
                    min-height: 15px;
                    display: block;
                    border-radius: 50%;
                    background: $main-color;
                    color: #fff;
                    text-align: center;
                    line-height: 15px;
                    font-size: 8px;
                    top: -8px;
                    right: -8px;
                }

                &:last-child{
                    margin-left: 20px;
                }
            }
        }

        .search-input{
            position: relative;
            animation: fade 2s;
            max-width: 600px;
            margin: auto;
            input{
                width: 100%;
                height: 40px;
                text-indent: 10px;
                outline: none;
                padding-right: 40px;
                border: 0;
                font-size: 30px;

                @include placeholder-color(#BDBEBF);
            }
            span{
                position: absolute;
                right: 0;
                font-size: 20px;
                top: 0;
                bottom: 0;
                margin: auto;
                line-height: 40px;
                display: block;
                width: 40px;
                text-align: center;
                cursor: pointer;
            }
        }

        .close-search{
            display: block;
            position: absolute;
            width: 20px;
            height: 20px;
            right: 10px;
            top: 0;
            bottom: 0;
            margin: auto;
            &:before, &:after{
                content: '';
                left: 0;
                right: 0;
                height: 1px;
                margin: auto;
                display: block;
                background: $main-color;
                top: 50%;
                position: absolute;
            }
            &:before{
                transform: rotate(45deg);
            }
            &:after{
                transform: rotate(-45deg);
            }
        }

        .mega-menu{
            position: absolute;
            z-index: 2000;
            top: 0;
            background: #fff;
            left: 0;
            right: 0;
            padding-bottom: 30px;
            animation: fadeDown 0.5s;


            h3{
                margin-top: 0;
                font-size: 16px;
                font-family: $font-bold;
                margin-bottom: 5px;
            }

            ul{
                li{
                    line-height: 30px;
                    a{
                        font-size: 16px;
                        font-family: $font-bold;
                    }
                }
            }

            img{
                width: 100%;
                height: 300px;
                object-fit: cover;
            }
            span{
                margin-top: 15px;
                display: block;
                font-size: 14px;
            }
        }

        .mega-menu-overlay{
            position: fixed;
            z-index: 1000;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
            background: rgba(0,0,0,0.6);
        }
    }
</style>
